import UserForgotPasswordFlow from "./UserForgotPasswordFlow";

export default UserForgotPasswordFlow;
